import { active } from 'd3';
import React from 'react'
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { addAllemployees, addemployee ,updateemployee} from 'Redux/Reducer/EmployeeSlice';
import AxiosService from 'utils/AxiosService';

function UseEmployeeHook() {

const dispatch = useDispatch();
const createEmployee = async (data) => {
  try {
    
    const val = {
      name: data?.name,
      mobile: data?.whatsappNumber,
      email: data?.email,
      role: data?.role,
      active: data?.active ?? true,
      permissions: {
        canAddProduct: data?.permissions?.canAddProduct || false,
        canAddService: data?.permissions?.canAddService || false,
        canAddCombo: data?.permissions?.canAddCombo || false
      }
    };

    const res = await AxiosService.post("/vendor/createEmployee", val);

    if (res.status === 201) {
      toast.success(res.data.message);
      dispatch(addemployee(res?.data?.employee));
    }
  } catch (error) {
    console.log(error);
  }
};

    const getAllEmployee = async() => {
        try {
            let res =await AxiosService.get("/vendor/getVendorEmployee");
            // console.log(res.data)
            if(res.status == 200){
                dispatch(addAllemployees(res?.data?.employees));
            }
        } catch (error) {
            console.log(error);
        }
    }
  const updateEmployee = async (data) => {
    // console .log("data in hook",data)
  try {
    const val = {
      name: data?.name,
      mobile: data?.whatsappNumber || data?.mobile,
      email: data?.email,
      role: data?.role,
      active: data?.active,
      permissions: {
        canAddProduct: data?.permissions?.canAddProduct || false,
        canAddService: data?.permissions?.canAddService || false,
        canAddCombo: data?.permissions?.canAddCombo || false
      }
    };

    const res = await AxiosService.put(`/vendor/updateEmployee/${data?._id}`, val);

    if (res.status === 200) {
      toast.success(res.data.message);
      dispatch(updateemployee(res?.data?.employee));
    }
  } catch (error) {
    console.log(error);
  }
};
    const getAlluserByAdmin = async() => {
        try {
            let res =await AxiosService.get("/admin/users");
            // console.log(res.data)
            if(res.status == 200){
                dispatch(addAllemployees(res?.data));
            }
        } catch (error) {
            console.log(error);
        }
    }
  return {createEmployee,getAllEmployee,updateEmployee,getAlluserByAdmin}
}

export default UseEmployeeHook